import { create } from 'zustand'
import itemService from '../../services/admin/itemService'

const useAdminItemStore = create((set) => ({
    items: [],
    item: null,
    loading: false,
    validationErrors: [],
    error: null,

    // Fetch all items
    fetchItems: async (params) => {
        set({ loading: true, error: null })
        try {
            const response = await itemService.getItems(params)
            set({ items: response.data, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    // Fetch item by ID
    fetchItemDetail: async (id) => {
        set({ loading: true, error: null })
        try {
            const response = await itemService.getItemById(id)
            set({ item: response.data, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    // Create a new item
    createItem: async (itemData) => {
        set({ loading: true, error: null })
        try {
            const response = await itemService.createItem(itemData)
            set((state) => ({
                items: [...state.items, response.data],
                loading: false,
            }))
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    // Update an existing item
    updateItem: async (id, itemData) => {
        set({ loading: true, error: null })
        const response = await itemService.updateItem(id, itemData)
        if (response.success) {
            set((state) => ({ item: itemData, loading: false }))
            return { success: true, data: response.data }
        } else {
            set((state) => ({ validationErrors: response.messages, loading: false }))
            return { success: false, messages: response.messages }
        }
    },

    // Delete an item
    deleteItem: async (id) => {
        set({ loading: true, error: null })
        try {
            await itemService.deleteItem(id)
            set((state) => ({
                items: state.items.filter((item) => item.id !== id),
                loading: false,
            }))
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },
}))

export default useAdminItemStore
